import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { Skeleton } from '@crehana/compass.ui';
import useCentralizedOrgSlug from "../../../hooks/useCentralizedOrgSlug";
import { MenuLink } from "./components";
import { LinkWithDropdown } from "./components/link-with-dropdown";
import { Subtitle } from "./components/subtitle";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var _MenuLinkComponent = function MenuLinkComponent(_ref) {
  var _item$children;
  var item = _ref.item,
    onClickItem = _ref.onClickItem,
    onClickModule = _ref.onClickModule,
    currentSingleRoute = _ref.currentSingleRoute,
    sidebarType = _ref.sidebarType,
    centralizedId = _ref.centralizedId;
  switch (item.type) {
    case 'url':
    case 'module':
      return /*#__PURE__*/_jsx(MenuLink, {
        menuLink: item,
        onClickItem: onClickItem,
        onClickModule: onClickModule,
        currentActive: currentSingleRoute,
        sidebarType: sidebarType,
        centralizedId: centralizedId
      });
    case 'dropdown':
      return /*#__PURE__*/_jsx(LinkWithDropdown, {
        menuLink: item,
        onClickItem: onClickItem,
        currentActive: currentSingleRoute,
        sidebarType: sidebarType,
        centralizedId: centralizedId
      });
    case 'group':
      return /*#__PURE__*/_jsxs("div", {
        className: "tw-mt-1.6",
        children: [/*#__PURE__*/_jsx(Subtitle, {
          text: item.label
        }), (_item$children = item.children) === null || _item$children === void 0 ? void 0 : _item$children.map(function (child) {
          return /*#__PURE__*/_jsx(_MenuLinkComponent, {
            item: child,
            onClickItem: onClickItem,
            onClickModule: onClickModule,
            currentSingleRoute: currentSingleRoute,
            sidebarType: sidebarType,
            centralizedId: centralizedId
          }, child.code);
        })]
      });
    default:
      return /*#__PURE__*/_jsx("div", {
        children: item.label
      });
  }
};
export { _MenuLinkComponent as MenuLinkComponent };
export var MenuLinks = function MenuLinks(_ref2) {
  var _ref2$links = _ref2.links,
    links = _ref2$links === void 0 ? [] : _ref2$links,
    onClickModule = _ref2.onClickModule,
    currentSingleRoute = _ref2.currentSingleRoute,
    isLoading = _ref2.isLoading,
    onClickItem = _ref2.onClickItem,
    sidebarType = _ref2.sidebarType,
    organizationSlug = _ref2.organizationSlug;
  var _useCentralizedOrgSlu = useCentralizedOrgSlug({
      organizationSlug: organizationSlug || ''
    }),
    centralizedId = _useCentralizedOrgSlu.centralizedId,
    loading = _useCentralizedOrgSlu.loading;
  if (isLoading || loading) {
    return /*#__PURE__*/_jsx("ul", {
      children: /*#__PURE__*/_jsx("li", {
        className: "tw-px-1.2",
        children: _toConsumableArray(Array(8)).map(function (_, idx) {
          return /*#__PURE__*/_jsx(Skeleton
          // biome-ignore lint/suspicious/noArrayIndexKey: index as key is acceptable here
          , {
            className: "tw-w-full tw-h-4 tw-my-0.8 tw-rounded-0.8"
          }, idx);
        })
      })
    });
  }

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (!links) return null;
  return /*#__PURE__*/_jsx("ul", {
    className: "tw-w-full",
    children: links.map(function (item) {
      return /*#__PURE__*/_jsx(_MenuLinkComponent, {
        item: item,
        onClickItem: onClickItem,
        currentSingleRoute: currentSingleRoute,
        onClickModule: onClickModule,
        sidebarType: sidebarType,
        centralizedId: centralizedId
      }, item.label);
    })
  });
};